import { DefeasedPaymentsContent } from './DefeasedPaymentsContent';

export default DefeasedPaymentsContent;
